import { Feature, getProductId, PlanInterval } from '../../../../models';

const TRUE_BUNDLE_ECOM_PRODUCT_IDS: Partial<Record<Feature, string>> = {
  [Feature.TRUE_AUTOMATION]: 'true_automation_ecom',
  [Feature.TRUE_PLATFORM_ONLY]: 'true_platform_ecom',
};

export const getManualPurchaseProductId = (
  feature: Feature,
  interval: PlanInterval,
): string => (interval === PlanInterval.YEAR
  ? TRUE_BUNDLE_ECOM_PRODUCT_IDS[feature] ?? getProductId(feature)
  : getProductId(feature));

export const getManualPurchaseProductCode = (
  feature: Feature,
  interval: PlanInterval,
): string => `${getManualPurchaseProductId(feature, interval)}_${PlanInterval.getPlanIntervalCode(interval)}`;
